import type {WaitlistItemModel} from '../../../domain/WaitlistItem/WaitlistItem.model';

export abstract class FetchUserWaitlistItemsQuery {
  abstract fetch(
    props?: FetchUserWaitlistItemsQuery.Props,
  ): Promise<FetchUserWaitlistItemsQuery.Response>;
}

export namespace FetchUserWaitlistItemsQuery {
  export type Props = unknown;

  export type Response = WaitlistItemModel[];
}
